import { StyleSheet } from '@react-pdf/renderer'

const mainStyles = StyleSheet.create({
  page: {
    padding: 20,
  },
  headerContainer: {
    marginTop: 16,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 5,
  },
  headerTitle: {
    fontSize: 15,
    fontWeight: 'bold',
  },
  headerCaseWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerCaseLabel: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  headerCaseValue: {
    fontSize: 12,
  },
  detailsGrid: {
    flexDirection: 'row',
    gap: 20,
  },
  procedureDetailsSection: {
    flex: 1,
  },
  patientDetailsSection: {
    flex: 1,
  },
  questionnaireSection: {
    width: '100%',
    marginTop: 10,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  emptyHeader: {
    height: 50,
  },
  addressBlock: {
    marginBottom: 10,
    textAlign: 'center',
  },
  addressText: {
    fontSize: 10,
  },
  footer: {
    position: 'absolute',
    bottom: 15,
    right: 30,
    textDecoration: 'none',
  },
  poweredByTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  poweredByText: {
    color: '#5035ed',
    fontSize: 8,
    fontWeight: 'bold',
    marginRight: 5,
    textDecoration: 'none',
  },
  repInfoSection: {
    marginTop: 10,
    backgroundColor: '#F5F5F5',
    borderRadius: 5,
  },
})

const cardStyles = StyleSheet.create({
  container: {
    backgroundColor: '#F5F5F5',
    padding: 10,
    height: 70,
    borderRadius: 5,
  },
  containerWithLongText: {
    backgroundColor: '#F5F5F5',
    padding: 8,
    height: 80,
    borderRadius: 5,
  },
  title: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 12,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 7,
  },
  label: {
    fontSize: 10,
    width: 90,
  },
  value: {
    fontSize: 10,
  },
  valueLong: {
    fontSize: 8,
    width: 280,
  },
  valueLonger: {
    fontSize: 7,
    width: 280,
  },
  questionnaireContainer: {
    marginBottom: 10,
    backgroundColor: '#f8f9fa',
    padding: 12,
    height: 90,
    borderRadius: 5,
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
  questionRow: {
    flexDirection: 'row',
    marginBottom: 4,
  },
  question: {
    fontSize: 10,
    flex: 3,
  },
  answer: {
    fontSize: 10,
    flex: 1,
    fontWeight: 'bold',
  },
  noQuestions: {
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: 10,
  },
  repContainer: {
    display: 'flex',
    flexDirection: 'row',
    padding: 10,
  },
  repLabel: {
    fontSize: 10,
    fontWeight: 'bold',
    marginRight: 15,
  },
  repValue: {
    fontSize: 10,
    flexWrap: 'wrap',
    marginBottom: 5,
  },
  repGrid: {
    width: '100%',
    marginTop: 1,
    gap: 2,
  },
  repRow: {
    flexDirection: 'row',
    width: '100%',
  },
  repCell: {
    width: '33.33%',
    paddingRight: 8,
  },
  repValueItem: {
    fontSize: 9,
  },
})

const tableStyles = StyleSheet.create({
  container: {
    backgroundColor: '#F5F5F5',
    marginBottom: 40,
  },
  headerRow: {
    flexDirection: 'row',
    backgroundColor: '#E0E0E0',
    padding: 8,
  },
  rowEven: {
    flexDirection: 'row',
    padding: 8,
    backgroundColor: '#F5F5F5',
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
    height: 49,
    maxHeight: 49,
  },
  rowOdd: {
    flexDirection: 'row',
    padding: 8,
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
    height: 49,
    maxHeight: 49,
  },
  cell: {
    fontSize: 9,
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  cellDefault: {
    fontSize: 9,
    flex: 1,
    flexWrap: 'wrap',
    alignItems: 'center',
  },
})

export { mainStyles, cardStyles, tableStyles }
